/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateDeliveryParcelRequestDeliveryParcel } from './CreateDeliveryParcelRequestDeliveryParcel';
import {
    CreateDeliveryParcelRequestDeliveryParcelFromJSON,
    CreateDeliveryParcelRequestDeliveryParcelFromJSONTyped,
    CreateDeliveryParcelRequestDeliveryParcelToJSON,
} from './CreateDeliveryParcelRequestDeliveryParcel';

/**
 * 
 * @export
 * @interface CreateDeliveryParcelRequest
 */
export interface CreateDeliveryParcelRequest {
    /**
     * 
     * @type {CreateDeliveryParcelRequestDeliveryParcel}
     * @memberof CreateDeliveryParcelRequest
     */
    deliveryParcel?: CreateDeliveryParcelRequestDeliveryParcel;
}

/**
 * Check if a given object implements the CreateDeliveryParcelRequest interface.
 */
export function instanceOfCreateDeliveryParcelRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateDeliveryParcelRequestFromJSON(json: any): CreateDeliveryParcelRequest {
    return CreateDeliveryParcelRequestFromJSONTyped(json, false);
}

export function CreateDeliveryParcelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDeliveryParcelRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deliveryParcel': !exists(json, 'delivery_parcel') ? undefined : CreateDeliveryParcelRequestDeliveryParcelFromJSON(json['delivery_parcel']),
    };
}

export function CreateDeliveryParcelRequestToJSON(value?: CreateDeliveryParcelRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'delivery_parcel': CreateDeliveryParcelRequestDeliveryParcelToJSON(value.deliveryParcel),
    };
}

